import { render, staticRenderFns } from "./editAvatar.vue?vue&type=template&id=4b76d291"
import script from "./editAvatar.vue?vue&type=script&lang=js"
export * from "./editAvatar.vue?vue&type=script&lang=js"
import style0 from "./editAvatar.vue?vue&type=style&index=0&id=4b76d291&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports